/**
 * Marca nós do Ferrugini Inspetor (DEV). Radix Dialog/Sheet trata pointerdown
 * "fora" do conteúdo como fechar — o HUD fica fora do modal, então precisamos
 * ignorar dismiss quando o alvo for o Inspetor.
 */
export const FERRUGINI_INSPETOR_UI_ATTR = "data-ferrugini-inspetor-ui" as const;

export const ferruginiInspetorUiMark = { [FERRUGINI_INSPETOR_UI_ATTR]: "" } as const;

export function shouldIgnoreDismissForFerruginiInspetor(event: {
  target: EventTarget | null;
  detail?: { originalEvent?: Event };
}): boolean {
  const raw =
    (event.detail?.originalEvent?.target as EventTarget | null) ?? event.target;
  return (
    typeof document !== "undefined" &&
    raw instanceof Element &&
    raw.closest(`[${FERRUGINI_INSPETOR_UI_ATTR}]`) != null
  );
}
